import React from 'react';
import Modal from 'react-modal';
import { useTranslation } from 'react-i18next';
import './TalentCardView.css'; // Reuse styles

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    maxWidth: '800px',
    maxHeight: '90vh',
    overflowY: 'auto',
    padding: '0', // Remove padding to use our own styled container
    border: 'none',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
    zIndex: 1000,
  },
};

Modal.setAppElement('#root');

// A simplified view to display card details inside the modal
function ModalTalentCardView({ cardData }) {
  const { t } = useTranslation();

  if (!cardData) {
    return <div>{t('loading')}</div>;
  }

  const formatDate = (timestamp) => {
    if (!timestamp) return 'N/A';
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    return date.toLocaleDateString();
  };

  return (
    <div className="container" style={{padding: '2rem'}}>
      <header className="profile-header">
        <div>
          <h1>{cardData.name}</h1>
          <p>{cardData.title}</p>
        </div>
      </header>
      <div className="profile-body">
        <aside className="profile-sidebar">
          {cardData.skills?.length > 0 && (
            <div className="section">
              <h3>{t('skills')}</h3>
              <div className="skills-list">
                {cardData.skills.map((skill, index) => (
                  <span key={index} className="skill-tag">{skill}</span>
                ))}
              </div>
            </div>
          )}
           <div className="section">
              <h3>Details</h3>
              <ul className="info-list">
                {cardData.availability && <li><strong>{t('availability')}</strong><span>{cardData.availability}</span></li>}
                {cardData.locationPreferences && <li><strong>{t('locationPreferences')}</strong><span>{cardData.locationPreferences}</span></li>}
                {cardData.values?.length > 0 && <li><strong>{t('values')}</strong><span>{cardData.values.join(', ')}</span></li>}
              </ul>
            </div>
        </aside>
        <main className="profile-main">
          <div className="section">
            <h3>{t('professionalSummary')}</h3>
            <p>{cardData.summary}</p>
          </div>
          {cardData.experience?.length > 0 && (
            <div className="section">
              <h3>{t('workExperience')}</h3>
              {cardData.experience.map((exp, index) => (
                <div key={index} className="experience-item">
                  <h4>{exp.role}</h4>
                  <p className="company">{exp.company} | {exp.duration}</p>
                </div>
              ))}
            </div>
          )}
           <div className="section timestamps">
            <p><strong>{t('created')}:</strong> {formatDate(cardData.createdAt)}</p>
          </div>
        </main>
      </div>
    </div>
  );
}


function TalentCardModal({ isOpen, onRequestClose, card }) {
  const { t } = useTranslation();
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={customStyles}
      contentLabel="Talent Card Details"
    >
      <div className="modal-content" style={{ position: 'relative' }}>
        {card ? (
          <>
            <button 
              onClick={(e) => {
                e.preventDefault();
                const url = `/talent-card/${card.id}`;
                window.open(url, '_blank', 'noopener,noreferrer');
                window.focus();
              }}
              className="btn btn-secondary"
              style={{ position: 'absolute', top: '20px', right: '20px', zIndex: 10 }}
            >
              {t('viewTalentCard')}
            </button>
            <ModalTalentCardView cardData={card} />
          </>
        ) : (
          <p style={{padding: '20px'}}>{t('loading')}</p>
        )}
      </div>
    </Modal>
  );
}

export default TalentCardModal;
